import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
export var ImagesAndStatus = function ImagesAndStatus(_ref) {
  var imagesList = _ref.imagesList,
    handleImageClick = _ref.handleImageClick,
    encounter = _ref.encounter,
    isLoadingImage = _ref.isLoadingImage,
    statusInfo = _ref.statusInfo;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] text-left text-gray-500 dark:text-gray-500 mb-1"
  }, t("label.images")), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] text-left text-gray-700 dark:text-gray-300"
  }, imagesList.length > 0 ? imagesList.map(function (image, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: idx
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return handleImageClick(image, encounter, image.sourceType, image.sourceData);
      },
      disabled: isLoadingImage,
      className: "text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 hover:underline cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed underline"
    }, image.name), idx < imagesList.length - 1 && " | ");
  }) : "-")), /*#__PURE__*/React.createElement("span", {
    className: "px-3 py-1 rounded-full text-[10px] text-left ".concat(statusInfo.className)
  }, statusInfo.label));
};